import { APP_MIGRATION_AVAILABLE } from "@faire/web-api--source/indigofair/settings/APP_MIGRATION_AVAILABLE";

import { getSettingValueWithoutAssignment } from "./__internal__/getSetting";

export const getSettingAppMigrationAvailable = (): boolean =>
  getSettingValueWithoutAssignment(APP_MIGRATION_AVAILABLE, false);
